var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl } from 'shared/components';
import { useDeprecationIsOverridden, useFieldIsDeprecated } from '../hooks';
export var DeprecatedFormControl = function (_a) {
    var name = _a.name, forceShow = _a.forceShow, _b = _a.valueCheck, valueCheck = _b === void 0 ? function (value) { return !!value; } : _b, formControlProps = __rest(_a, ["name", "forceShow", "valueCheck"]);
    var _c = useFormContext(), getValues = _c.getValues, setValue = _c.setValue;
    var isDeprecated = useFieldIsDeprecated(name);
    var isOverridden = useDeprecationIsOverridden(name, valueCheck);
    useEffect(function () {
        // if field is deprecated and still is a draft, remove any value that may be set
        // skip if forceShow is on (ie deprecation is not yet active due to feature flag)
        if (isDeprecated && !isOverridden && valueCheck(getValues(name)) && !forceShow) {
            setValue(name, '');
        }
    }, [forceShow, getValues, setValue, isOverridden, isDeprecated]);
    if (isDeprecated && !isOverridden && !forceShow) {
        return _jsx(_Fragment, {});
    }
    return _jsx(FormControl, __assign({}, formControlProps));
};
